<template>
  <div>
    <div class="card-group mb-0">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-gear" /> Set Up Google 2FA
        </div>
        <div class="card-block">
          <h6>Two-factor authentication (2FA) strengthens access security by requiring two methods (also referred to as factors) to verify your identity.</h6>
          <h6>It protects against phishing, social engineering, and password brute force attacks and secures your logins from attackers exploiting weak or stolen credentials.</h6>
          <p>You can install Google Authenticator application using these links: <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" target="_blank">Android</a> | <a href="https://apps.apple.com/ru/app/google-authenticator/id388497605" target="_blank">iOS</a></p>

          <div class="mt-20">
            <button v-if="!getGoogle2faInfo && !secret_key" class="btn btn-success" @click="generateSecret">
              Generate Secret Key to Enable 2FA
              <span v-if="loading" class="btn-loader" />
            </button>

            <EnableGoogle2FA
              v-if="!getGoogle2faInfo && secret_key"
              :secret-key="secret_key"
              :qr-code="qr_code"
              @getErrors="setErrors"
            />

            <DisableGoogle2FA
              v-if="getGoogle2faInfo"
              @getErrors="setErrors"
              @resetSecretKey="resetSecretKey"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="errors" class="card card-inverse card-danger">
      <div class="card-header">
        Errors
      </div>
      <div class="card-block">
        {{ errors }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EnableGoogle2FA from './EnableGoogle2FA';
import DisableGoogle2FA from './DisableGoogle2FA';

export default {
  name: 'Google2FA',

  components: {
    EnableGoogle2FA,
    DisableGoogle2FA,
  },

  data: () => ({
    secret_key: null,
    qr_code: null,
    loading: false,
    errors: null,
  }),

  computed: {
    ...mapGetters('user', [
      'getGoogle2faInfo',
    ]),
  },

  methods: {
    generateSecret() {
      if (this.loading) return;
      this.loading = true;
      this.$apiHttp.post(`${this.$config.app_api.host}${this.$config.app_api.prefix}2fa/generate-secret`)
        .then((response) => {
          if (response.data.secret_key) {
            this.errors = null;
            this.secret_key = response.data.secret_key;
            this.qr_code = response.data.qr_code;
          }
        })
        .catch((e) => {
          this.errors = e.message;
          console.error(e.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setErrors(val) {
      this.errors = val;
    },
    resetSecretKey() {
      this.secret_key = null;
      this.qr_code = null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Google2FA.vue?6df40ac6